module.exports = __webpack_public_path__ + "img/music-note-list.f776705f.svg";